import React from "react";
import {
  Tag,
  Heading,
  Lead,
  PageHero,
  Section,
  BtnPrimary,
} from "../components/UI";
import StatsBar from "../components/StatsBar";
import styles from "./About.module.css";

const VALUES = [
  {
    icon: "💡",
    t: "Cost-Effective Quality",
    d: "We deliver consistently high-quality solutions at competitive prices, ensuring maximum ROI for every client.",
  },
  {
    icon: "🌍",
    t: "Global Expertise",
    d: "Serving clients across India and the United States with deep understanding of both markets and cultures.",
  },
  {
    icon: "🤝",
    t: "Reliable Partnership",
    d: "Long-term relationships built on transparency, accountability, and measurable, real-world results.",
  },
  {
    icon: "🚀",
    t: "Innovation First",
    d: "Continuously adopting cutting-edge technologies to ensure our clients stay ahead in competitive markets.",
  },
  {
    icon: "🎯",
    t: "Goal-Oriented Delivery",
    d: "Every project is aligned to clear business objectives with defined milestones and success metrics.",
  },
  {
    icon: "🔒",
    t: "Security & Compliance",
    d: "We build with security-first principles and adhere to industry compliance standards globally.",
  },
];

const TEAM_HIGHLIGHTS = [
  { num: "10+", label: "Years of Experience" },
  { num: "200+", label: "Projects Delivered" },
  { num: "50+", label: "Expert Professionals" },
  { num: "98%", label: "Client Satisfaction" },
];

export default function About() {
  return (
    <>
      <PageHero
        tag="About Us"
        title="A Trusted Partner for Business & Technology"
        subtitle="Metawave Solutions is a global team of talented professionals delivering cost-effective, high-quality business solutions across software, HR, and staffing."
      />

      {/* ── Story ─────────────────────────────────────────────── */}
      <Section variant="paper">
        <div className={styles.storyGrid}>
          <div>
            <Tag>Our Story</Tag>
            <Heading>Who We Are</Heading>
            <p className={styles.bodyText}>
              Metawave Solutions is a team of talented professionals
              specializing in Software Development, Application Development, HR
              Services, Staffing, and Outsourcing Services. Supported by an
              experienced pool of experts, we have built strong capabilities in
              delivering cost-effective, high-quality, consistent, and reliable
              business solutions to corporate clients across the globe.
            </p>
            <p className={styles.bodyText}>
              We provide dependable software development and HR services, along
              with advanced business solutions, catering to a wide range of
              organizations—from dynamic small and medium enterprises to Fortune
              100+ companies.
            </p>
            <BtnPrimary to="/contact-us" style={{ marginTop: "1.8rem" }}>
              Work With Us
            </BtnPrimary>
          </div>

          <div className={styles.highlights}>
            {TEAM_HIGHLIGHTS.map(({ num, label }, i) => (
              <div key={i} className={styles.highlightCard}>
                <div className={styles.highlightNum}>{num}</div>
                <div className={styles.highlightLabel}>{label}</div>
              </div>
            ))}
          </div>
        </div>
      </Section>

      <StatsBar />

      {/* ── Values ────────────────────────────────────────────── */}
      <Section variant="white">
        <Tag>Our Values</Tag>
        <Heading>What Drives Us</Heading>
        <Lead>
          These principles guide every project, partnership, and decision we
          make.
        </Lead>
        <div className={styles.valuesGrid}>
          {VALUES.map((v, i) => (
            <div key={i} className={styles.valueCard}>
              <div className={styles.valueIcon}>{v.icon}</div>
              <h3 className={styles.valueTitle}>{v.t}</h3>
              <p className={styles.valueDesc}>{v.d}</p>
            </div>
          ))}
        </div>
      </Section>

      {/* ── Pillars ───────────────────────────────────────────── */}
      {/* <Section variant="ink">
        <Tag light>What We Do</Tag>
        <Heading light>Our Service Pillars</Heading>
        <div className={styles.pillarsGrid}>
          {[
            { t: 'HR Solutions',        d: 'Specialized HR services to clients in India across different sectors.' },
            { t: 'Staffing Services',   d: 'Highest quality support to clients and candidates — from consulting to direct placements.' },
            { t: 'BPO / Outsourcing',   d: 'Back-office services in the BPO industry serving diverse global clients.' },
            { t: 'IT Training',         d: 'State-of-the-art e-learning with certified instructors for career advancement.' },
            { t: 'Software Dev',        d: 'End-to-end custom software, web, mobile, and enterprise application development.' },
            { t: 'Direct Placement',    d: 'Permanent placement services connecting top talent with leading organizations.' },
          ].map((p, i) => (
            <div key={i} className={styles.pillar}>
              <div className={styles.pillarNum}>0{i + 1}</div>
              <h4 className={styles.pillarTitle}>{p.t}</h4>
              <p className={styles.pillarDesc}>{p.d}</p>
            </div>
          ))}
        </div>
      </Section> */}

      {/* ── CTA ───────────────────────────────────────────────── */}
      {/* <Section variant="paper" style={{ textAlign: 'center' }}>
        <Heading>Ready to Get Started?</Heading>
        <Lead style={{ margin: '0 auto 2rem' }}>
          Let's discuss how Metawave Solutions can help your organization grow.
        </Lead>
        <BtnPrimary to="/contact">Contact Us →</BtnPrimary>
      </Section> */}
    </>
  );
}
